const twelveHours = 12 * 60 * 60 * 1000;

const config = {
  resources: {
    absolute: {
      campaignService: 'https://cma.cdn.shared-testing.audibene.net/campaign',
      marketingService: 'https://marketingservice.shared-testing.audibene.net/session',
      leadHandlerMapping: {
        'm.cdn.shared-testing.hear.com': 'https://leadhandler-cdn.shared-testing.audibene.net/lead/',
        'm.cdn.shared-testing.audibene.de': 'https://leadhandler-cdn.shared-testing.audibene.net/lead/'
      },
      leadHandler: 'https://leadhandler-origin.shared-testing.audibene.net/lead/',
      reactivationMapping: {
        'm.cdn.shared-testing.hear.com': 'https://leadhandler-cdn.shared-testing.audibene.net/crm/reactivation',
        'm.cdn.shared-testing.audibene.de': 'https://leadhandler-cdn.shared-testing.audibene.net/crm/reactivation'
      },
      reactivation: 'https://leadhandler-origin.shared-testing.audibene.net/crm/reactivation',
      eventTracker: 'https://et.shared-testing.audibene.net/services/collector/event',
      questionnaireVariables: 'https://formservice-origin.shared-testing.audibene.net/variables/minimal',
      customerDataService: 'https://customer.shared-testing.audibene.net'
    },
    relative: {
      customerDataService: '/customer-data-service'
    }
  },
  timeout: {
    marketingService: 15000,
    leadHandler: 15000,
    leadHandlerRead: 1000
  },
  validityTime: {
    reactivationGid: twelveHours
  },
  endpoint: {
    leadHandler: '/short'
  }
};

config.resources.relative = {
  ...config.resources.absolute,
  ...config.resources.relative
};

export default config;
